import * as Sentry from '@sentry/react';
import { StatsigClient } from '@statsig/react-bindings';

export const sentryTrack = (eventName, data = {}) => {
  try {
    if (
      !StatsigClient.instance().checkGate('web-ordering-sentry-event-logging')
    )
      return;
    // Sentry Log attributes must be flat primitives — extract top-level ones
    const attributes = {};
    for (const [key, value] of Object.entries(data)) {
      if (
        typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      ) {
        attributes[key] = value;
      }
    }
    Sentry.logger.info(eventName, attributes);
  } catch {
    // no-op — don't let logging break the app
  }
};
